import axios from "axios";
import SendIcon from "@mui/icons-material/Send";
import { apiUrl, razorpayKey } from "../../constants";
import { Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const addScript = (src) => {
  const script = document.createElement("script");
  script.src = src;
  document.querySelector("body").appendChild(script);
};

const PurchaseBtn = ({
  counters,
  setCounters,
  total_amount,
  phone_no,
  name = "",
  email = "",
  contact = "",
  setExistingFuningoMoney,
}) => {
  const [invoiceNumber, setInvoiceNumber] = useState();
  phone_no = phone_no.slice(-10);

  const getCurrentSno = async () => {
    try {
      const invoiceSnoData = await axios.get(`${apiUrl}/bill/billsno`);
      let currentInvoiceNumber = invoiceSnoData.data.message;
      setInvoiceNumber(currentInvoiceNumber);
    } catch (error) {
      console.log("Error fetching invoice number: " + error.message);
    }
  };
  useEffect(() => {
    getCurrentSno();
  }, []);
  const currentDate = new Date().toLocaleDateString("en-US");
  const handlePayment = async () => {
    try {
      const requestData = {
        total_amount,
        coins: counters.yellow,
        phone_no: "+91-" + phone_no,
      };
      addScript("https://checkout.razorpay.com/v1/checkout.js");
      let response = await axios.post(
        `${apiUrl}/user/coins/create-order`,
        requestData
      );
      response = response.data;
      const options = {
        key: razorpayKey,
        name: "Funingo Adventure Park",
        amount: total_amount,
        currency: "INR",
        description: "Test Transaction",
        order_id: response.id,
        handler: async (res) => {
          try {
            let resp = await axios.post(`${apiUrl}/user/coins/verify-payment`, {
              razorpay_payment_id: res.razorpay_payment_id,
              razorpay_signature: res.razorpay_signature,
              order_id: response.id,
              phone_no: "+91-" + phone_no,
              coins: counters.yellow,
              total_amount,
            });
            if (resp) {
              setCounters({
                red: 0,
                green: 0,
                yellow: 0,
              });
              setExistingFuningoMoney(resp.data.coins || 0);

              const salesId = await axios.get(`${apiUrl}/insights/salesId`);
              let Id = salesId.data.nextId;
              const [month, day, year] = currentDate.split("/");
              const formattedDate = `${year}-${month.padStart(
                2,
                "0"
              )}-${day.padStart(2, "0")}`;

              const responseSales = await axios.post(
                `${apiUrl}/insights/salesadd`,
                {
                  _id: Id,
                  date: formattedDate,
                  amount: total_amount,
                  section: "Ticket Counter",
                  split: "Activities",
                }
              );

              const responseBill = await axios.post(
                `${apiUrl}/bill/billpayment`,
                {
                  sno: invoiceNumber,
                  Date: currentDate,
                  CashAmount: 0,
                  OnlineAmount: total_amount,
                  paymentType: "RAZORPAY",
                  amount: total_amount - 2 * (total_amount * 0.09),
                  discount: 0,
                  discountType: "NA",
                  cgst: total_amount * 0.09,
                  sgst: total_amount * 0.09,
                  total: total_amount,
                }
              );
              toast.success("Recharge Done", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          } catch (error) {
            console.error(error.message, error);
          }
        },
        theme: {
          color: "#3399cc",
        },
        prefill: {
          name,
          email,
          contact,
        },
      };
      const razorpay = window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment Error!!", error.message, error);
    }
  };
  return (
    <>
      <Button
        endIcon={<SendIcon />}
        variant="contained"
        sx={{
          background: "#2CC248",
          boxShadow: "0px 2.5 9 0px rgba(0, 0, 0, 0.25)",
          borderRadius: "50px",
          padding: "10px 30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          "&:hover": {
            background: "#1e8e33",
          },
        }}
        onClick={() => {
          handlePayment();
        }}
      >
        <Typography
          sx={{
            fontFamily: "Luckiest Guy",
            fontSize: "24px",
            position: "relative",
            textAlign: "center",
          }}
        >
          Buy Now
        </Typography>
      </Button>
    </>
  );
};

export default PurchaseBtn;
